// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDUtNpVhn5f10nVr3kiGrCChaUIhHTEJUQ",
  authDomain: "thehookup-dca4d.firebaseapp.com",
  projectId: "thehookup-dca4d",
  storageBucket: "thehookup-dca4d.firebasestorage.app",
  messagingSenderId: "359119168940",
  appId: "1:359119168940:web:6ecbc0819f89eeee210609",
  measurementId: "G-LVH4REPNY1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
// Auto-detect when WebChannel/fetch streaming is blocked (Safari ITP, ad
// blockers, strict networks) and fall back to long polling — prevents the
// Listen/channel "access control checks" errors.
const db = initializeFirestore(app, { experimentalAutoDetectLongPolling: true });

const storage = getStorage(app);

export { app, analytics, auth, db, storage, firebaseConfig };
